// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : ADDED COMMENTS
// MODFIED DATA : 07-12-2025

// Verion : 0.0.2
// LastEdit : AGALYA
// Last ADD : ADDED COMMENTS
// MODFIED DATA : 28-02-2026

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** *********************  START GET ACCURED INTEREST REPORT DETAILS  ******************** */
export const getAccuredInterestReportDetails = (fetchData: any) => {
	const data = {
		GetAccuredInterestReportDetailsToken: fetchData,
	};
	const url = `${API_URL}PostAccruedInterestReport`;
	return makeApiCall(url, data);
};
/** *********************  END GET ACCURED INTEREST REPORT DETAILS  ******************** */
